import ChatImage from '@/ui/components/ChatImage/ChatImage'

import type { StatusVisual as StatusVisualSpec } from './types/StatusMessageTypes'

interface StatusVisualProps {
    visual?: StatusVisualSpec
    title?: string
}

const toSize = (size?: number) => (size === undefined ? 'var(--chat-image-size)' : `${size}rem`)

// The column of the visual (`--chat-image-container-size`) with the image / icon centred in it
const StatusVisual = ({ visual, title }: StatusVisualProps) => {
    if (visual?.kind === 'none') return null

    const size = toSize(visual?.size)
    const rounded = visual?.rounded
    const frame = {
        width: size,
        height: size,
        ...(rounded ? { borderRadius: '50%', overflow: 'hidden' as const } : {}),
    }

    return (
        <div className="status-message__visual-wrapper">
            <div
                className="status-message__visual"
                style={visual?.kind === 'image' ? { ...frame, backgroundColor: visual.background } : frame}
            >
                {visual?.kind === 'image' && (
                    <ChatImage image={visual.src} size={visual.size} backgroundColor={visual.background} rounded={visual.rounded} />
                )}
                {visual?.kind === 'icon' && (
                    <i
                        className={`a-icon boschicon-bosch-ic-${visual.name}${visual.rounded ? ' rounded' : ''}`}
                        title={title}
                        style={{ fontSize: size, width: size, height: size }}
                    />
                )}
            </div>
        </div>
    )
}

export default StatusVisual
